import './Layout.scss';
import * as React from 'react';

export interface LayoutPropsInterface {
  style?: React.CSSProperties;
}

export class Layout extends React.Component<LayoutPropsInterface, {}> {
  public render(): JSX.Element {
    return (
      <div style={this.props.style} className="Controlled Layout">
        {this.props.children}
      </div>
    );
  }
}

export class LayoutColumn extends React.Component<LayoutPropsInterface, {}> {
  public render(): JSX.Element {
    return (
      <div style={this.props.style} className="Controlled LayoutColumn">
        {this.props.children}
      </div>
    );
  }
}
